import { render, staticRenderFns } from "./GridBuyBox.vue?vue&type=template&id=3fcd5224&scoped=true"
import script from "./GridBuyBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./GridBuyBox.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./GridBuyBox.vue?vue&type=style&index=0&id=3fcd5224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcd5224",
  null
  
)

export default component.exports